import React from 'react';
import { connect } from 'react-redux';

import { HtmlContent } from '@dndbeyond/character-components/es';
import { rulesEngineSelectors, Constants, RuleData, RuleDataUtils } from '@dndbeyond/character-rules-engine/es';

import { SidebarHeader } from '../../../components/Sidebar';
import { SharedAppState } from '../../../stores/typings';

interface Props {
    ruleData: RuleData;
}
class InitiativePane extends React.PureComponent<Props> {
    render() {
        const { ruleData } = this.props;

        let rule = RuleDataUtils.getRule(Constants.RuleKeyEnum.INITIATIVE, ruleData);
        let description: string = '';
        if (rule && rule.description) {
            description = rule.description;
        }

        return (
            <div className="ct-initiative-pane">
                <SidebarHeader>Initiative</SidebarHeader>
                <HtmlContent className="ct-initiative-pane__description" html={description} />
            </div>
        );
    }
}

function mapStateToProps(state: SharedAppState) {
    return {
        ruleData: rulesEngineSelectors.getRuleData(state),
    };
}

export default connect(mapStateToProps)(InitiativePane);
